import { useCallback } from 'react'
import ProjectMemberApi from '../../../../../lib/functions/projectMember'
import { MentionType } from '../../../../../store/comments'
import { MentionSuggestionData } from '../../../../containers/Comment/CommentEditor/lib/Converter'

export const useMentionData = () => {
  const getMentionData = useCallback(
    async (
      projectUuid: string | undefined,
      query: string
    ): Promise<MentionSuggestionData[]> => {
      if (!projectUuid) return []
      try {
        const projectMembers = await ProjectMemberApi.search(query, {
          projectUuid,
        })
        return (projectMembers || []).map(user => {
          return {
            avatar: user.iconUrl,
            name: user.name,
            description: '',
            userUuid: user.uuid,
            mentionType: MentionType.USER,
          } as MentionSuggestionData
        })
      } catch (error) {
        console.error('Error fetching project members:', error)
        return []
      }
    },
    []
  )

  const getProjectMentionData = useCallback(
    (
      projectUuid: string | undefined,
      query: string
    ): MentionSuggestionData[] => {
      const targetStr = 'project'
      if (projectUuid && targetStr.includes(query)) {
        return [
          {
            name: targetStr,
            description: '',
            userUuid: projectUuid,
            mentionType: MentionType.PROJECT_MEMBER,
          } as MentionSuggestionData,
        ]
      }
      return []
    },
    []
  )

  return { getMentionData, getProjectMentionData }
}
